
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"8.75"}},[_c('path',{attrs:{"d":"M70 43.75v35m0 17.5h0m0 0a2.188 2.188 0 102.188 2.188A2.188 2.188 0 0070 96.25"}}),_c('path',{attrs:{"d":"M135.625 70a21.88 21.88 0 00-15.272-20.86A21.875 21.875 0 0090.86 19.647a21.88 21.88 0 00-41.72 0A21.875 21.875 0 0019.647 49.14a21.88 21.88 0 000 41.72 21.875 21.875 0 0029.493 29.493 21.88 21.88 0 0041.72 0 21.875 21.875 0 0029.493-29.493A21.887 21.887 0 00135.625 70z"}})])])
          )
        }
      }
    